<template>
  <div id="cor-searchbar">
    <div class="widthBarWrap" id="searchBarWrap">
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <div class="searchContainer">
            <h3 style="display: inline-block">
              Search our great Products & Services
            </h3>
            <v-combobox
              v-model="searchText"
              :items="categoryServices"
              :filter="filterSearch"
              prepend-inner-icon="mdi-magnify"
              hide-no-data
              placeholder="Search"
              solo
              auto-select-first
              hide-details
              id="searchInput"
              style="height: 20px; display: inline-block; padding-left: 50px"
              @keyup.enter.native="doSearch()"
              @input="doSearch()"
              :menu-props="{ openOnClick: false }"
            />
          </div>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({
      searchText: "",
      searchLocation: "",
    }),
    computed: {
      ...mapGetters({
        categoryServices: "business/categoryServices",
      }),
    },
    methods: {
      filterSearch(item, queryText, itemText) {
        const hasValue = (val) => (val != null ? val : "");

        const text = hasValue(itemText);
        const query = hasValue(queryText);

        return (
          text
            .toString()
            .toLowerCase()
            .indexOf(query.toString().toLowerCase()) === 0
        );
      },
      doSearch() {
        if (typeof this.searchText === "undefined") {
          this.$router.push(`/searchResults`);
        } else {
          this.searchText = encodeURI(this.searchText);
          this.$router.push(`/searchResults/service/${this.searchText}`);
        }
      },
    },
  };
</script>

<style scoped>
  .widthBarWrap {
    position: relative;
    background: #4cc7e8;
    width: 100vw;
    top: 0px;
    height: 100px;
  }

  #searchBarWrap {
    position: relative;
    height: 75px;
  }

  .searchContainer {
    position: relative;
    margin: auto;
    text-align: center;
    margin-top: 8px;
    /* max-width: 75%; */
  }

  .searchContainer h3 {
    font-weight: bold !important;
    font-size: 15pt !important;
    color: white;
  }

  .searchContainer h1 {
    font-weight: bold !important;
    font-size: 30pt !important;
    color: white;
    margin-top: 20px;
  }

  @media only screen and (max-width: 632px) {
    #searchBarWrap {
      height: 140px;
    }
    .v-input {
      padding-left: 0 !important;
    }
  }
</style>